import type { CSSProperties, ReactElement, ReactNode } from 'react';
import { Tooltip } from 'antd';

export function EntityMetric({
  label,
  labelTooltip,
  value,
  hint,
  hintStyle,
  exact,
  testId,
}: {
  label: string;
  labelTooltip?: string;
  value?: ReactNode;
  hint?: string | null | undefined;
  hintStyle?: CSSProperties;
  exact?: string | undefined;
  testId?: string;
}): ReactElement {
  return (
    <div className="entity-metric">
      <Tooltip title={labelTooltip}>
        <h2 className="entity-metric-label">{label}</h2>
      </Tooltip>
      <Tooltip title={exact}>
        <span className="entity-metric-value" data-testid={testId}>
          {value === null || value === undefined || value === '' ? '—' : value}
        </span>
      </Tooltip>
      {hint ? (
        <Tooltip title={hint}>
          <span className="entity-meta entity-metric-hint" style={hintStyle}>
            {hint}
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
}
